export const userAgent = navigator.userAgent.toLocaleLowerCase();
export const isMobile = /AppleWebKit.*Mobile.*/i.test(navigator.userAgent);
export const isAndroid = /android|adr|linux/gi.test(userAgent);
export const isiOS = /ipad|iphone|ipod/.test(userAgent);
export const isIpad = /ipad/.test(userAgent);
export const isPad = /(ipad|android_hd)/i.test(userAgent);
export const isSafari = /safari/.test(userAgent);
export const isWechat = /micromessenger/i.test(userAgent);
export const isQQ = /qq\//.test(userAgent);
export const isWeibo = /_weibo_/.test(userAgent);

export enum ENV {
  LOCAL = "local",
  PREVIEW = "preview",
  PRE = "pre",
  PRODUCTION = "production",
  DYNAMIC = "dynamic",
  ILLEGAL = "illegal"
}

export function detectEnv(): ENV {
  const host = window.location.host;
  const pathname = window.location.pathname;

  // 域名前缀2的场景
  if (host.indexOf("activity.bilibili.com") > -1) {
    // 判断路径是否非法
    if (pathname.indexOf("/blackboard/") > -1) {
      return ENV.ILLEGAL;
    }

    // 判断预览和预发
    if (pathname.indexOf("/preview/v/") > -1) {
      return ENV.PRE;
    } else if (pathname.indexOf("/preview/") > -1) {
      return ENV.PREVIEW;
    }

    // 此域名下仅有预览和预发环境，其他为非法
    return ENV.ILLEGAL;
  }

  // 域名前缀1 + 正式环境的场景
  if (host.indexOf("www.bilibili.com") > -1) {
    // 判断路径是否非法
    if (pathname.indexOf("/blackboard/") < 0) {
      return ENV.ILLEGAL;
    }

    // 判断预览和预发
    if (pathname.indexOf("/preview/v/") > -1) {
      return ENV.PRE;
    } else if (pathname.indexOf("/preview/") > -1) {
      return ENV.PREVIEW;
    }

    // 符合 /blackboard/ 路径且不含 preview 相关，为正式环境
    return ENV.PRODUCTION;
  }

  // 其他 bilibili 域名视作是本地环境
  if (host.match(/.*\.bilibili\.com/)) {
    return ENV.LOCAL;
  }

  // 动态域名: 域名为非*.bilibili.com，且 不含 blackboard 路径，且不含 preview 相关
  if (pathname.indexOf("/blackboard/") < 0 && pathname.indexOf("/preview/") < 0) {
    return ENV.DYNAMIC;
  }

  return ENV.ILLEGAL;
}

export function getTargetURLByENV(targetId: string, env: ENV = detectEnv()): string {
  // 动态域名默认使用 www.bilibili.com 进行拼接
  // 本地环境默认使用 activity.bilibili.com 进行拼接
  const host =
    env === ENV.DYNAMIC ? "www.bilibili.com" : env === ENV.LOCAL ? "activity.bilibili.com" : window.location.host;

  const protocol = env === ENV.DYNAMIC ? "https:" : window.location.protocol;
  const arr = [protocol + "/", host];

  if (host === "www.bilibili.com") {
    arr.push("blackboard");
  }

  if (env === ENV.PREVIEW || env === ENV.LOCAL) {
    arr.push("preview");
  } else if (env === ENV.PRE) {
    arr.push("preview/v");
  }

  arr.push(targetId[0] === "/" ? targetId.slice(1) : targetId);

  return arr.join("/");
}

export function getSafeImageUrlByENV(url: string, env: ENV = detectEnv()): string {
  if (env === ENV.DYNAMIC) {
    const hostname = `${location.protocol}//${location.hostname}`;
    return url.replace(/^http(s)?:\/\/i[0-2]\.hdslb\.com/, `${hostname}/bfs`);
  }

  return url.replace(/https?/, "https");
}

export function parseParamToObj(obj) {
  if (!obj) {
    return;
  }
  let str = obj.search;
  if (!str) {
    str = obj.hash;
  }
  const index = str.indexOf("?");
  str = str.substring(index + 1);
  const result = {};
  const paramArray = str.split("&");
  for (let i = 0, len = paramArray.length; i < len; i++) {
    const pair = paramArray[i].split("=");
    if (pair[1] === "") {
      pair.push("");
    }
    result[pair[0]] = pair[1];
  }
  return result;
}

export function judgeUa() {
  if (isAndroid) {
    return "android";
  }
  if (isiOS) {
    return "ios";
  }
  return "";
}
